const scrollable = () => ({
    scrolledStart: true,
    scrolledEnd: false,

    handleScroll() {
        this.$nextTick(() => {
            const element = this.$refs.scrollable
            // Gone (the cart's strips go when its last line is removed) or hidden (x-show), so there's nothing to
            // measure: watchScroller runs this again once a hidden scroller shows
            if (!element?.offsetWidth) {
                return
            }
            this.scrolledStart = element.scrollLeft <= 1
            this.scrolledEnd = element.scrollLeft >= (element.scrollWidth - element.offsetWidth - 1)
        })
    },
    // Keeps the arrows right when the scroller is shown, resized or filled, none of which fire a scroll event.
    // Each observer stops once the scroller has been removed (an x-if around the strip), which still fires them.
    watchScroller() {
        const element = this.$refs.scrollable
        let queued = false
        const update = (records, observer) => {
            if (!element.isConnected) {
                observer.disconnect()
                return
            }
            if (queued) {
                return
            }
            queued = true
            requestAnimationFrame(() => {
                queued = false
                this.handleScroll()
            })
        }
        new ResizeObserver(update).observe(element)
        new MutationObserver(update).observe(element, {
            childList: true, subtree: true, attributes: true, attributeFilter: ['style'],
        })
    },
    scrollBack() {
        const element = this.$refs.scrollable
        const row = this.wholeCardRow()
        if (row) {
            element.scrollLeft = Math.max(0, (Math.ceil(element.scrollLeft / row - 0.01) - 1) * row)
        } else {
            element.scrollLeft -= this.calculateScrollAmount() // (this.$refs.card.offsetWidth * 3)
        }
    },
    scrollForward() {
        const element = this.$refs.scrollable
        const row = this.wholeCardRow()
        if (row) {
            element.scrollLeft = (Math.floor(element.scrollLeft / row + 0.01) + 1) * row
        } else {
            element.scrollLeft += this.calculateScrollAmount() // (this.$refs.card.offsetWidth * 3)
        }
    },
    calculateScrollAmount() {
        const element = this.$refs.scrollable
        const computed = getComputedStyle(element)
        return element.offsetWidth - parseFloat(computed.paddingLeft) - parseFloat(computed.paddingRight)
    },
    // When whole cards exactly fill the visible width (the cart's strips from md up), the width of a row of them plus
    // the gap after it, so each page starts on a card. The page is worked out from the position rather than added to
    // it, as scrollLeft holds whole pixels and the rounding would add up. Otherwise null: paging moves by the visible width.
    wholeCardRow() {
        const element = this.$refs.scrollable
        const card = [...element.children].find((child) => child.tagName === 'DIV' && child.offsetParent !== null)
        if (!card) {
            return null
        }
        const computed = getComputedStyle(element)
        const gap = parseFloat(computed.columnGap) || 0
        const row = element.getBoundingClientRect().width - parseFloat(computed.paddingLeft) - parseFloat(computed.paddingRight) + gap
        const pitch = card.getBoundingClientRect().width + gap
        const perRow = Math.round(row / pitch)
        return perRow > 0 && Math.abs(perRow * pitch - row) < 1 ? perRow * pitch : null
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('scrollable', scrollable)
})

export default scrollable
